import React from 'react';
import { GetLoadList_getLoadListByJobId as LoadType } from '../../../types/schemaTypes';
import { NoResult, useLazyLoading, Loading } from '../../_common';
import LoadItem from '../../ListItem/LoadItem';
import './LoadList.scss';

interface SelectedLoad {
    loadId: number | null;
    boxNumber: string | null;
}

interface LoadListProps {
    jobId: number | null | undefined;
    abortRequest: () => void;
    loadList: any[];
    isLoading: boolean;
    isEndOfResults: boolean;
    entries: (any | null)[];
    onLoadMore: () => void;
    selectedLoads: SelectedLoad[];
    setSelectedLoads: (loadItems: SelectedLoad[]) => void;
    refetch: () => void;
}

const LoadList = ({
    jobId,
    abortRequest,
    loadList,
    isLoading,
    isEndOfResults,
    onLoadMore,
    selectedLoads,
    setSelectedLoads,
    refetch,
}: LoadListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('loadList', isLoading, isEndOfResults, onLoadMore);
    const onLoadItemCheck = (checkedStatus: boolean, load: LoadType): void => {
        let result: SelectedLoad[] = [];
        if (checkedStatus === true) {
            result = selectedLoads.concat({ loadId: load.loadId, boxNumber: load.boxNumber });
        } else if (checkedStatus === false) {
            result = selectedLoads.filter((item): boolean => item.loadId !== load.loadId);
        }

        setSelectedLoads(result);
    };

    const isLoadChecked = (load: LoadType): boolean => {
        return selectedLoads.filter((item): boolean => item.loadId === load.loadId)[0] !== undefined;
    };

    if (isLoading) {
        return (
            <div className="LoadList-Loading">
                <Loading />
            </div>
        );
    }

    return (
        <div className="JobLoads-LoadList 123" id="loadList" onScroll={handleScroll}>
            {loadList && loadList.length === 0 ? (
                <NoResult isModal={false} />
            ) : (
                loadList &&
                loadList.map(
                    (load): React.ReactElement => {
                        return (
                            <LoadItem
                                jobId={jobId ? jobId : load.jobId}
                                abortRequest={abortRequest}
                                load={load}
                                key={load.loadId}
                                isChecked={isLoadChecked(load)}
                                onChange={(checkedStatus: boolean): void => onLoadItemCheck(checkedStatus, load)}
                                refetch={refetch}
                            />
                        );
                    },
                )
            )}
        </div>
    );
};

export default LoadList;
